export default class Room {
  constructor(json, contracted = false, ratePlan=null) {
    // Contracted
    if (contracted) {
      this.name = json.room_type
      this.description = null
      this.stayId = json.id
      this.total = json.price
    } else {
      // Retail
      this.name = json['@Name']
      this.description = json['@Description']
      this.stayId = null
      this.total = json.Total['@Amount']
      this.roomCode = json['@Code']
      this.gatewayFee = json['GatewayFee']['@Amount']
      this.taxAmount = json['Tax']['@Amount']
      this.bookingFee = json['BookingFee']['@Amount']
      this.currencyCode = json['@CurrencyCode']
      this.ratePlan = ratePlan
    }
  }
}
